import {Alert} from '@mui/material'
import {StyledAlertTitle} from './EmptyListAlertInfoStyles'
import PropTypes from 'prop-types'

const EmptyListAlertInfo = ({message}) => {
  return (
    <Alert data-testid='alert-component' severity='info'>
      <StyledAlertTitle>{message}</StyledAlertTitle>
    </Alert>
  )
}

EmptyListAlertInfo.propTypes = {
  message: PropTypes.string.isRequired
}

export default EmptyListAlertInfo
